import React from 'react'
import { useTranslation } from 'react-i18next'

import RadioBlock from '../../../../../../../components/Form/RadioBlock'

import { AD_TYPE_OPTION, IMAGE_EXISTING_LIBRARY_TYPE, IMAGE_EXTERNAL_HOST_TYPE, IMAGE_UPLOAD_TYPE } from '../../fields'

const ImageOptions = ({ chooseRoute, setChooseRoute }) => {
  const { t } = useTranslation()

  // The answers to this question will define which route the user takes (Route A, Route B or Route C)
  return (
    <>
      <RadioBlock
        setFieldValue={(fieldName, route) => setChooseRoute(route)}
        id="radio_type_upload_image"
        name={AD_TYPE_OPTION}
        value={IMAGE_UPLOAD_TYPE}
        selectedValue={chooseRoute}
        label={t('Upload image creatives')}
      />
      <RadioBlock
        setFieldValue={(fieldName, route) => setChooseRoute(route)}
        id="radio_type_external_host"
        name={AD_TYPE_OPTION}
        value={IMAGE_EXTERNAL_HOST_TYPE}
        selectedValue={chooseRoute}
        label={t('Use image creatives from an external host')}
      />
      <RadioBlock
        setFieldValue={(fieldName, route) => setChooseRoute(route)}
        id="radio_type_existing_library"
        name={AD_TYPE_OPTION}
        value={IMAGE_EXISTING_LIBRARY_TYPE}
        selectedValue={chooseRoute}
        label={t('Use existing image from the library')}
      />
    </>
  )
}

export default ImageOptions
